import { Col, Row, Input, message } from 'antd';
import { useCallback, useState } from 'react';
import { HelpdeskHttp } from '@/services';
import { AppButton, AppModal, Flex } from '../common';
import { HelpdeskMessageModalProps, HelpdeskStatus } from './helpdeskUtils';
import { useTranslation } from 'react-i18next';

export default function HelpdeskCancelModal({
  issue,
  onComplete,
  ...modalProps
}: HelpdeskMessageModalProps) {

  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(false);
  const [t] = useTranslation(['common', 'helpdesk']);

  const handleCancel = useCallback(() => {
    setNote('');
    setLoading(false);
    modalProps.hide();
  }, [modalProps, setNote]);

  const handleSubmit = useCallback(async () => {
    setLoading(true);
    try {
      await HelpdeskHttp.updateIssueNotes(issue.id, {
        issue: {
          ...(note ? { notes: note } : {}),
          status_id: HelpdeskStatus.Canceled,
        },
      });
      message.success({ content: t('helpdesk:messages.success-cancel') });
      handleCancel();
      onComplete();
    }
    catch (e) {
      message.error({ duration: 3, content: t('helpdesk:messages.fail-cancel') });
    }
  }, [issue, note, setLoading, onComplete, handleCancel]);

  return (
    <AppModal
      footer={null}
      destroyOnHidden
      onCancel={handleCancel}
      title={t('helpdesk:labels.cancel-request')}
      variant="helpdesk"
      {...modalProps}>
      <Row gutter={[12, 12]}>
        <Col span={24}>
          <Flex direction="column">
            <Input.TextArea
              rows={7}
              style={{ height: '100%' }}
              value={note}
              onChange={e => setNote(e.target.value)}
              placeholder={t('helpdesk:messages.write-cancel-reason')}
              className="placeholder-app-gray-darker text-app-gray-darker"
            />
          </Flex>
          <Flex className="mt-2" direction="column">
            <AppButton
              danger
              type="primary"
              loading={loading}
              onClick={handleSubmit}
              className="font-bold min-w-[6rem] mt-2 ms-auto !bg-[#E85549]"
            >
              {t('helpdesk:labels.cancel-request')}
            </AppButton>
          </Flex>
        </Col>
      </Row>
    </AppModal>
  );
}
